let nextFloatingWindowStackOrder = 0;

export function getNextFloatingWindowStackOrder(): number {
  nextFloatingWindowStackOrder += 1;
  return nextFloatingWindowStackOrder;
}
